import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};
export const createCouponCode = async (payload) => {
  const formattedPayload = {
    ...payload,
    CouponValue: Number(payload.CouponValue),
    MinValue: Number(payload.MinValue),
    NoOfUsages: Number(payload.NoOfUsages),
    ExpiryDate: new Date(payload.ExpiryDate).toISOString(), // Convert to ISO 8601
    CustomerId: payload.CustomerId || null, // empty string → null
    Published: Boolean(payload.Published),
    ProductId: Number(payload.ProductId),
  };

  return await axiosInstance.post("product/coupon", formattedPayload, {
    headers,
  });
};

export const updateCouponCode = async (payload) => {
  const formattedPayload = {
    ...payload,
    Id: Number(payload.Id),
    CouponValue: Number(payload.CouponValue),
    MinValue: Number(payload.MinValue),
    NoOfUsages: Number(payload.NoOfUsages),
    ExpiryDate: new Date(payload.ExpiryDate).toISOString(),
    CustomerId: payload.CustomerId || null,
    Published: Boolean(payload.Published),
    ProductId: Number(payload.ProductId),
  };

  return await axiosInstance.put("product/coupon", formattedPayload, {
    headers,
  });
};

export const fetchCouponCodes = async () => {
  return await axiosInstance.get("product/coupon", { headers });
};

export const deleteCouponCode = async (couponId) => {
  return await axiosInstance.delete(`product/coupon/${couponId}`, { headers });
};
export const publishCouponCode = async (id) => {
  return await await axiosInstance.patch(`product/coupon/${id}/publish`, {
    headers,
  });
};

export const unPublishCouponCode = async (id) => {
  return await await axiosInstance.patch(`product/coupon/${id}/unpublish`, {
    headers,
  });
};

export const fetchCouponCodebyId = async (id) => {
  const response = await axiosInstance.get(`product/coupon/${id}`, {
    headers,
  });
  return response.data;
};
